import React from 'react';

const VideoSection = ({
  videoSrc,
  autoPlay = true,
  muted = true,
  loop = true
}) => {
  // Inline styles
  const videoSectionStyle = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000', // fallback background
    overflow: 'hidden',
    padding: '0',
  };

  const videoContainerStyle = {
    width: '100%',
    maxWidth: '1600px', // For large screens, limit the width
    maxHeight: '800px',  // Optional: control max height
    aspectRatio: '16/9', // Maintain aspect ratio
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const videoStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'contain', // Prevent cutting video content
  };

  return (
    <div style={videoSectionStyle}>
      <div style={videoContainerStyle}>
        <video
          muted={muted}
          loop={loop}
          src={videoSrc}
          autoPlay={autoPlay}
          style={videoStyle}
        />
      </div>
    </div>
  );
};

export default VideoSection;
